import { NotificationConfirmConsentRequest } from '@calm/evexia-web-sdk';
import useAccount from '@rhg/hooks/use-account';
import createNotificationApi from '@rhg/libs/api/create-notification-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { useMutation } from '@rhg/libs/react-query';

export function useNotificationUserConsentUpdate() {
    const { getAccessTokenSilently } = useAuth();
    const { account } = useAccount();
    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async (payload: NotificationConfirmConsentRequest) => {
            const notificationsApi = createNotificationApi(
                getAccessTokenSilently
            );

            const response =
                await notificationsApi.confirmEmailCommunicationOptIn({
                    userId: account!.userId,
                    notificationConfirmConsentRequest: payload,
                });
            return response.data;
        },
    });
    return {
        notificationConsentUpdate: mutate,
        notificationConsentUpdateAsync: mutateAsync,
        ...otherProps,
    };
}
